module.exports = __webpack_public_path__ + "402f6e21923841ae166710707b2c4870.svg";